// Required
@import "bootstrap/scss/functions";
@import "bootstrap/scss/variables";
@import "bootstrap/scss/mixins";

// @import "bootstrap/scss/root";
@import "bootstrap/scss/reboot";
@import "bootstrap/scss/type";
@import "bootstrap/scss/images";
// @import "bootstrap/scss/code";
@import "bootstrap/scss/grid";
// @import "bootstrap/scss/tables";
// @import "bootstrap/scss/forms";
@import "bootstrap/scss/buttons";
// @import "bootstrap/scss/transitions";
// @import "bootstrap/scss/dropdown";
// @import "bootstrap/scss/button-group";
// @import "bootstrap/scss/input-group";
// @import "bootstrap/scss/custom-forms";
@import "bootstrap/scss/nav";
// @import "bootstrap/scss/navbar";
@import "bootstrap/scss/card";
// @import "bootstrap/scss/breadcrumb";
// @import "bootstrap/scss/pagination";
// @import "bootstrap/scss/badge";
// @import "bootstrap/scss/jumbotron";
// @import "bootstrap/scss/alert";
// @import "bootstrap/scss/progress";
@import "bootstrap/scss/media";
// @import "bootstrap/scss/list-group";
@import "bootstrap/scss/close";
// @import "bootstrap/scss/toasts";
@import "bootstrap/scss/modal";
// @import "bootstrap/scss/tooltip";
// @import "bootstrap/scss/popover";
// @import "bootstrap/scss/carousel";
// @import "bootstrap/scss/spinners";
@import "bootstrap/scss/utilities";
@import "bootstrap/scss/print";

body {
  padding-top: 13rem;

  @include media-breakpoint-up(md) {
    padding-top: 5rem;
  }
}

@media print {
  .fixed-top {
    position: relative;
  }
}

.nav-link.active {
  text-decoration: underline;
  font-weight: bold;
}

hr {
  margin: 1rem 0;

  @include media-breakpoint-up(md) {
    margin: 3rem 0;
  }
}

// @import 'foundation';

/* kalender */
.hyttestyret_kalender {
  width: 100%;

  border: 2px solid #DDD;
  border-collapse: collapse;
  margin-top: 20px;

  th {
    text-align: center;
    background-color: #EEE;

    span {
      display: block;
      font-size: 9px;
      font-weight: normal;
      color: #555;
    }
  }

  th span {
    &:before {
      content: "(";
    }

    &:after {
      content: ")";
    }
  }

  td,
  th {
    border: 1px solid #DDD;
    padding: 5px;
    line-height: 1em;
  }

  td.uke {
    background-color: #F3F3F3;
    text-align: center;
    font-size: 11px;
  }

  td.reservert:after,
  td.reservert2:after,
  td.reservert3:after {
    content: " (reservert)";
  }

  td {
    text-align: right;
    font-size: 10px;

    &.idag {
      border-bottom: 4px solid #AAA;

      &:after {
        content: " (i dag)";
        font-weight: bold;
      }

      span {
        font-weight: bold;
      }
    }

    .month {
      font-weight: bold;
    }
  }
}

.hyttestyret_legend.ledig span,
.hyttestyret_kalender td.ledig {
  background-color: #FFFFFF;
}
.hyttestyret_legend.reservert span,
.hyttestyret_kalender td.reservert {
  background-color: #FFFFAA;
}
.hyttestyret_legend.reservert-hs span,
.hyttestyret_kalender td.reservert-hs {
  background-color: #AAAAFF;
}
.hyttestyret_legend.beboerhelg span,
.hyttestyret_kalender td.beboerhelg {
  background-color: #AAFFAA;
}

.hyttestyret_legend.utleid span,
.hyttestyret_kalender td.utleid {
  background-color: #FFAAAA;
}

#hyttestyret_legends {
  text-align: right;
  margin-bottom: 30px;
}
.hyttestyret_legend {
  margin: 10px 0 0 15px;
  display: inline-block;

  span {
    margin-top: 4px;
    float: left;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    border: 1px solid #AAA;
  }
}
